export const MIN_SELECTED_FIDCS = 2;
export const MAX_SELECTED_FIDCS = 5;
